import React from 'react';
import { Navigate } from 'react-router-dom';
import { COOKIE_JWT } from 'common/AppConstant';
import store from 'app/store';
import { updateJwt } from 'features/login/state/reducer';
import { useSelector } from 'react-redux';
import RoutePath from './RoutePath';

export default function PrivateRoute({ children }) {
  const foundJwt = localStorage.getItem(COOKIE_JWT);
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  if (!foundJwt || foundJwt === 'null' || !isAdmin) {
    return <Navigate to={RoutePath.app.scenario.fullpath} replace />;
  }
  store.dispatch(updateJwt(foundJwt));
  return children;
}
